import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "colegal_aviso_pendientes";

export const PendientesAviso = () => {
  const { user } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (!user || sessionStorage.getItem(KEY) === user.id) return;
    if (user.role !== "owner" && !(user.role === "content_editor" && user.puede_aprobar)) return;
    sessionStorage.setItem(KEY, user.id);
    api.get("/copiloto/pendientes").then(({ data }) => {
      const partes = [];
      if (data.por_aprobar) partes.push(`${data.por_aprobar} por aprobar`);
      if (data.por_publicar) partes.push(`${data.por_publicar} por publicar`);
      if (partes.length) {
        toast.info(`Contenido del Copiloto: ${partes.join(" y ")}`, {
          duration: 12000, action: { label: "Revisar", onClick: () => nav("/app/admin/copiloto") },
        });
      }
      if (data.alertas_generacion) {
        toast.error(`${data.alertas_generacion} documento(s) no se generaron por un marcador sin reemplazar`, {
          duration: 15000, action: { label: "Ver", onClick: () => nav("/app/admin/plantillas") },
        });
      }
    }).catch(() => {});
  }, [user, nav]);
  return null;
};
